import React, { useRef } from 'react';

export const callContext = React.createContext();

const CallProvider = ({ children }) => {
  let callProp = useRef(null);
  return (
    <callContext.Provider value={callProp}>
      {children}
    </callContext.Provider>
  )
}

export default CallProvider;